module.exports = __webpack_public_path__ + "static/media/George Komsky.4b847159.jpg";